import { findAllDepartments } from '../../_services/department.service';

export const findAllDepartmentsEvent= async () => {
    let res = await findAllDepartments();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}